var MDB = window.MDB || {};
MDB.WidgetEditor = MDB.WidgetEditor || {};
MDB.WidgetEditor.WidgetHider = MDB.WidgetEditor.WidgetHider || {};

$.extend(MDB.WidgetEditor.WidgetHider, {
    boot: function (config) {

        var rolePicker = $('#WidgetHider_SelectedRoles');
        if (rolePicker.length) {
            rolePicker.kendoMultiSelect();
            rolePicker = rolePicker.closest('.k-multiselect');
        };

        var typePicker = $('#WidgetHider_Type');
        var valueInput = $('#WidgetHider_Value');
        var procedurePicker = $('#WidgetHider_StoredProcedure');
        var valDateTime = $('#valDateTime');
        var operatorDiv = $('.operatorDiv');


        prepareHiderControls();

        typePicker.change(function (e) {
            var value = e.target.value;

            valueInput.val("");
            prepareHiderControls(value);
        });

        valueInput.keydown(function (e) {
            var value = e.target.value;

            if (e.keyCode === 8) {
                if (value.endsWith("-") || value.endsWith(":") || value.endsWith(" ")) {
                    e.target.value = value.substring(0, value.length - 1);
                }
            }
        });

        valueInput.keyup(function (e) {
            var time = typePicker.val() === "Time";
            var value = e.target.value;

            if (time) {
                if (value.length === 2 || value.length === 5) {
                    e.target.value = value + ":";
                }
            } else {
                if (value.length === 2 || value.length === 5) {
                    e.target.value = value + "-";
                }
            }

            var max = time ? 9 : 11;
            if (!isNumber(e.keyCode) && e.keyCode !== 8 && !isIgnore(e.keyCode) || value.length >= max) {
                e.target.value = value.substring(0, value.length - 1);
            }
        });

        valueInput.blur(function (e) {
            var value = e.target.value;
            if (value.length === 6) {
                e.target.value = value + "00";
            }

            validateInput(e.target.value);
        });

        function isNumber(character) {
            var numbers = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
            return numbers.indexOf(character) !== -1;
        }

        function isIgnore(character) {
            var ignoreKeys = [13, 16, 9, 17, 18, 19, 20, 27, 33, 37, 38, 39, 40];
            return ignoreKeys.indexOf(character) !== -1;
        }

        function validateInput(input) {
            var time = typePicker.val() === "Time";
            var day = typePicker.val() === "Day";

            if (time) {
                if (!correctDateTime(input, false)) {
                    valDateTime.show();
                } else {
                    valDateTime.hide();
                }
            } else if (day) {
                if (!correctDateTime(input, true)) {
                    valDateTime.show();
                } else {
                    valDateTime.hide();
                }
            }
        }

        function correctDateTime(input, date) {
            var check;

            if (date) {
                check = moment(input, 'DD-MM-YYYY', true);
            } else {
                check = moment(input, 'HH:mm:ss', true);
            }
            return check.isValid();
        }

        function prepareHiderControls(value) {
            value = value === undefined ? config.Type : value;

            if (value === "Time") {
                controlToForeground(valueInput, value);
                valueInput.attr("placeholder", "16:53:00");

                if (valueInput[0].value.length > 8) {
                    valueInput[0].value = valueInput[0].value.split(' ')[1];
                }
            }
            if (value === "Day") {
                controlToForeground(valueInput, value);
                valueInput.attr("placeholder", "01-01-1990");

                if (valueInput[0].value.length > 10) {
                    valueInput[0].value = valueInput[0].value.split(' ')[0];
                }
            }
            if (value === "Role") {
                controlToForeground(rolePicker, value);
            }

            if (value === "StoredProcedure") {
                controlToForeground(procedurePicker, value);
            }
            if (value === "Value") {
                controlToForeground(valueInput, value);
                valueInput.attr("placeholder", "");

                $('.hiderColumn').each(function (index, div) {
                    div.style.display = "";
                });

            } else {
                $('.hiderColumn').each(function (index, div) {
                    div.style.display = "none";
                });
            }
        }

        function controlToForeground(control, type) {
            var controls = [procedurePicker, rolePicker, valDateTime, valueInput];

            if (type === "Time" || type === "Day" || type === "Value") {
                operatorDiv.show();
            } else {
                operatorDiv.hide();
            }

            controls.forEach(function (c) {
                if (c[0].id === control[0].id) {
                    c.show();
                } else {
                    c.hide();
                }
            });
        }
    }
});

